<template>
  <button
    v-if="subtle"
    :disabled="is_disabled || null"
    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-400 hover:bg-gray-200 hover:text-danger-600 disabled:opacity-50"
    data-test="fraction-delete"
    @click="submit"
  >
    <FontAwesomeIcon
      v-if="!is_loading"
      :icon="['far', 'trash-can']"
    />
    <FontAwesomeIcon
      v-else
      icon="spinner"
      pulse
    />
  </button>
  <PButton
    v-else
    :disabled="is_disabled || null"
    severity="danger"
    size="small"
    variant="outlined"
    @click="submit"
  >
    <div
      v-if="!is_loading"
      class="icon"
    >
      <FontAwesomeIcon
        icon="trash-can"
        size="sm"
      />
    </div>
    <div
      v-if="is_loading"
      class="icon"
    >
      <FontAwesomeIcon
        icon="spinner"
        pulse
      />
    </div>
    <div v-if="$slots.default">
      <slot />
    </div>
  </PButton>
</template>

<script setup>
import useGlobalConfirm from '@/composables/useGlobalConfirm';

const { confirm } = useGlobalConfirm();

const props = defineProps({
  is_outlined: { type: Boolean },
  is_light: { type: Boolean },
  is_disabled: { type: Boolean },
  is_loading: { type: Boolean },
  requires_confirmation: { type: Boolean },
  subtle: { type: Boolean },
});

const emit = defineEmits(['onClick']);

async function submit() {
  if (props.requires_confirmation) {
    const confirmed = await confirm({ destructive: true });
    if (!confirmed) return;
  }
  if (props.is_disabled) return;
  emit('onClick');
}
</script>

<style scoped>
.icon {
  font-size: 1.5em;
}
.icon svg {
  width: 1em;
  height: 1em;
}
</style>
